module.exports = {
      id: "mast-logo-usage",
      viewBox: "0 0 350 51",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#mast-logo",
      toString: function () {
        return this.url;
      }
    }